import React, { PureComponent } from 'react'
import { FormControl, InputLabel, Input } from '@material-ui/core'

import { isValidString } from '../../utils/string'

import ForwardRefHOC from '../../containers/HOC/ForwardRefHOC'
import ModalDialog from '../common/ModalDialog'

class AddComponentTypeModal extends PureComponent {
  state = {
    name: '',
  }

  addComponentType = () => {
    const { name } = this.state

    if (!isValidString(name)) {
      this.props.onError('Please provide a valid component type name')
      return
    }

    this.props.addComponentType({ name, active: true })
  }

  onClose = () => {
    this.setState({
      name: '',
    })
  }

  onOpen = (type) => {
    this.setState({
      name: '',
    })
  }

  onComponentTypeNameChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    })
  }

  render() {
    const { forwardedRef } = this.props

    const { name } = this.state

    return (
      <ModalDialog
        title={'Add Component Type'}
        ref={forwardedRef}
        onConfirm={this.addComponentType}
        onClose={this.onClose}
        onOpen={this.onOpen}
      >
        <FormControl fullWidth className="margin-bottom-small">
          <InputLabel>Name *</InputLabel>
          <Input
            name="name"
            value={name}
            onChange={this.onComponentTypeNameChange}
            fullWidth
            inputProps={{
              maxLength: 50,
            }}
          />
        </FormControl>
      </ModalDialog>
    )
  }
}

export default ForwardRefHOC(AddComponentTypeModal)



// WEBPACK FOOTER //
// ./src/components/Modal/AddComponentTypeModal.js